<template>
  <svg width="11px" height="16px" viewBox="0 0 11 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <desc>Back</desc>
    <defs></defs>
    <g id="back" transform="translate(-6, -4)">
      <polygon id="Shape" :fill="colors.mainActionColor" points="16.7666667 5.86666667 14.8747748 4 6.76666667 12 14.8747748 20 16.7666667 18.1333333 10.5504505 12"></polygon>
    </g>
  </svg>
</template>
<script lang="js">
  import { mapState } from 'vuex';

  export default {
    name: 'BackGlyph',
    computed: {
      ...mapState(['colors']),
    },
  };
</script>
